<template>
  <!-- <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion> -->
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Harga Token</h3>
                  </div>
                </div>
              </div>


              <div class="row" v-if="aiBalance.is_available == true || dataParam.api_key != ''">
                <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3" v-if="aiDetail.is_waajo_api_key == 0">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon">
                        <i class="fa fa-asterisk"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3>
                          Token
                        </h3>
                        <span>
                          {{ calculateToken() }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon">
                        <i class="fa fa-signal"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3>
                          AI Status
                        </h3>
                        <span class="text text-success" v-if="aiBalance.is_available == true">
                          <i class="fa fa-check"></i> Available
                          <small v-if="aiDetail.trial_status == 1" class="text-muted">free</small>
                        </span>
                        <span class="text text-danger" v-else>
                          <i class="fa fa-remove"></i> Not Available
                        </span>
                        <!-- <span class="text text-info" v-if="aiDetail.trial_status == 1">
                          <br /> <i class="fa fa-date"></i> Berlaku hingga: {{
                            formatFromUnixToDate(aiDetail.trial_expire) }}
                        </span> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon">
                        <i class="fa fa-magic"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3>
                          {{ nFormatter(rowTotalTokenAI.total_tokens) }}
                        </h3>
                        <span>
                          Saldo Token AI
                         
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon">
                        <i class="fa fa-file"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3 class="text text-danger">
                          {{ nFormatter(rowTotalTokenAI.total_tokens_used) }}
                        </h3>
                        <span>
                          Token Digunakan
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="setupKey" class="was-validated">
                    <ai-pricing :getAIKey="getAIKey" :getBalance="getBalance" :getAIDetail="getAIDetail"
                      :aiDetail="aiDetail" />
                  </form>
                </div>
              </div>

            </div>
          </div>

        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarChatbot.vue";
import { nFormatter, formatFromUnixToDate } from "@/utils/helper";
import AiPricing from "./components/AiPricing.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    AiPricing
  },
  data() {
    return {
      rowTotalTokenAI: {
        "total_tokens": "0",
        "total_tokens_used": "0",
      },
      aiDetail: {
        ai_engine: '',
        trial_status: 1,
        trial_expire: 0
      },
      pricePerUsd: 0.0000001647, //base on deepseek
      aiBalance: {
        is_available: false,
        balance_infos: [
          {
            currency: "USD",
            total_balance: "0",
            granted_balance: "0.00",
            topped_up_balance: "0.00"
          }
        ]
      },
      isLoading: false,
      dataParam: {
        api_key: "",
        ai_engine: "deepseek"
      },
      AiModels: [
        {
          id: "deepseek",
          label: "DeepSeek",
          status: true
        },
        {
          id: "gpt-4",
          label: "GPT-4",
          status: false
        },
        {
          id: "gpt-4o",
          label: "GPT-4o",
          status: false
        },
        {
          id: "gpt-4o-mini",
          label: "GPT-4o Mini",
          status: false
        },
        {
          id: "gpt-o1",
          label: "GPT-o1",
          status: false
        },
        {
          id: "gpt-o3",
          label: "GPT-o3",
          status: false
        },
        {
          id: "gpt-o3",
          label: "GPT-o3-mini",
          status: false
        },
        {
          id: "gpt-4.5",
          label: "GPT-4.5",
          status: false
        },
      ],
    };
  },

  created() {
    // console.log("xx")
    this.getAIKey();
    this.getBalance();
    this.getAIDetail();
    this.getTotalTokenAI();
  },
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    async getTotalTokenAI() {
      this.$store
        .dispatch("dashboard/TotalTokenAI") // sesuai kan dengan method di API
        .then(response => {
          var { data } = response
          this.rowTotalTokenAI = data
        });
    },
    formatFromUnixToDate(unxTimestamp) {
      return formatFromUnixToDate(unxTimestamp)
    },
    getAIDetail() {
      // this.licenseArrLoading = true;
      this.$store
        .dispatch("aiKey/getDetail") // sesuai kan dengan method di API
        .then(response => {
          let { data } = response;
          this.aiDetail = data
          // console.log("ai detail", data)
        });
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    calculateToken() {
      let total = parseFloat(this.aiBalance.balance_infos[0].total_balance) / this.pricePerUsd;
      return this.nFormatter(total)
    },
    setupKey(isRedirect = false) {
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/setupKey", this.dataParam)
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.$fire({
            title: "Success",
            text: "Data berhasil disimpan",
            type: "success",
            timer: 2000
          });
          this.getBalance();
          // if (isRedirect == true) {
          //   this.$router.push("/farm-contact/list")
          // }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getAIKey() {
      // console.log("geetttt")
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/getAIKey")
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.dataParam.api_key = data
        })
        .catch(err => {
          // console.log("errr",err)
          this.isLoading = false;
        });
    },
    getBalance() {
      // console.log("geetttt")
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/getBalance")
        .then(response => {
          this.isLoading = false;
          let { data } = response;
          this.aiBalance = data
        })
        .catch(err => {
          // console.log("errr",err)
          this.isLoading = false;
        });
    },
  },
  mounted() {
  },
  name: "settingsAIKey"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/AiListPricing.vue